import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../components/Logo";
import { useLang } from "../i18n";
import { legalContent } from "../legalContent";
import { Reveal } from "../components/Reveal";

export default function Legal({ kind }) {
  const { lang, t } = useLang();
  const doc = legalContent[lang][kind];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [kind]);

  return (
    <div data-testid={`legal-page-${kind}`} className="min-h-screen bg-oris-cream">
      <div className="border-b border-oris-green/10 bg-white">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-5 py-5 sm:px-8">
          <Link to="/" data-testid="legal-logo-link" aria-label="ORIS INTERNATIONAL">
            <Logo tone="dark" compact />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 border border-oris-green/25 px-4 py-2 text-xs font-bold uppercase tracking-widest text-oris-green transition-colors hover:border-oris-gold hover:text-oris-gold"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            {t.admin.back}
          </Link>
        </div>
      </div>

      <main className="mx-auto max-w-4xl px-5 py-16 sm:px-8 lg:py-20">
        <Reveal>
          <span className="mb-5 inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.24em] text-oris-moss">
            <span className="gold-rule" aria-hidden="true" />
            {doc.overline}
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h1 data-testid="legal-title" className="font-serif text-4xl font-medium tracking-tight text-oris-ink sm:text-5xl lg:text-6xl">
            {doc.title}
          </h1>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-4 text-xs font-semibold uppercase tracking-[0.2em] text-oris-gold">{doc.updated}</p>
        </Reveal>

        <div className="mt-12 divide-y divide-oris-green/10 border-y border-oris-green/10">
          {doc.sections.map((s, i) => (
            <Reveal key={s.heading} delay={i * 0.04}>
              <section data-testid={`legal-section-${i}`} className="grid gap-3 py-8 sm:grid-cols-12">
                <h2 className="font-serif text-2xl font-medium text-oris-ink sm:col-span-4">{s.heading}</h2>
                <p className="text-sm leading-relaxed text-oris-moss sm:col-span-8 lg:text-base">{s.body}</p>
              </section>
            </Reveal>
          ))}
        </div>

        <p className="mt-16 text-xs tracking-wide text-oris-moss/60">{t.footer.rights}</p>
      </main>
    </div>
  );
}
